import { W_Status } from '../api-new';

export const bg_color = (status: W_Status) => {
  if (status === 4) return 'bg-green-500';
  if (status === 3) return 'bg-blue-500';
  if (status === 2) return 'bg-yellow-500';
  if (status === 1) return 'bg-red-500';
  return 'bg-gray-500';
};

export const gradient_color = (status: W_Status) => {
  if (status === 4) return 'bg-gradient-to-b from-green-500 to-white';
  if (status === 3) return 'bg-gradient-to-b from-blue-500 to-white';
  if (status === 2) return 'bg-gradient-to-b from-yellow-500 to-white';
  if (status === 1) return 'bg-gradient-to-b from-red-500 to-white';
  return 'bg-gradient-to-b from-gray-500 to-white';
};

export const text_color = (status: W_Status) => {
  if (status === 4) return 'text-green-500';
  if (status === 3) return 'text-blue-500';
  if (status === 2) return 'text-yellow-500';
  if (status === 1) return 'text-red-500';
  return 'text-gray-500';
};

export const border_color = (status: W_Status) => {
  if (status === 4) return 'border-green-500';
  if (status === 3) return 'border-blue-500';
  if (status === 2) return 'border-yellow-500';
  if (status === 1) return 'border-red-500';
  return 'border-gray-500';
};
